// เนื้อหาหน้า "วิธีทำงาน" — ขั้นตอนงาน 4 สายของผู้ประสานงานนำเข้า
//
// ⚠ ที่มาของเนื้อหา: ไฟล์ส่งมอบงาน CAMP_STUDIO_International_Coordinator_Handover_v2-1.xlsx
//   ชีต Process - Purchasing / Import / Meeting / Brand Email
//   ผู้เขียน: ปรินทร อุษณวศิน · ทุกชีตระบุไว้เองว่า **EMPLOYEE DRAFT / NOT APPROVED SOP**
//   และช่อง "Approved as SOP" = "NO — จนกว่าบริษัทจะอนุมัติเป็นลายลักษณ์อักษร"
//
//   ⇒ หน้านี้จึงต้องขึ้นป้ายบอกตรง ๆ ว่าเป็น "ร่าง" เสมอ (ดู DRAFT_NOTE)
//      ห้ามเอาป้ายออกจนกว่า user จะบอกว่าบริษัทอนุมัติแล้ว — ไม่งั้นพนักงานใหม่
//      จะเข้าใจว่านี่คือกติกาที่บริษัทรับรอง ซึ่งยังไม่จริง
//
//   แก้ของเดิมเฉพาะคำที่พิมพ์ผิดชัด ๆ (คว่มพร้อม→ความพร้อม · ถุกต้อง→ถูกต้อง · ปรินมาณ→ปริมาณ ·
//   ข้อกำหมด→ข้อกำหนด · ชะระ→ชำระ · Yusem→Yusen · Emai→Email · ไฟล์ทบิน→ไฟลท์บิน)
//   เนื้อความไม่ได้เปลี่ยน ไม่ได้เติมขั้นตอนที่ชีตไม่มี
//   + ชื่อแบรนด์เขียน **CAMP STUDIO ตัวพิมพ์ใหญ่ทั้งหมดเสมอ** (user สั่ง 17 ต.ค. 2569 — ต้นฉบับพิมพ์ 'Camp Studio')

export const DRAFT_NOTE =
  'ร่างจากผู้ที่ส่งมอบงาน — ยังไม่ใช่ขั้นตอนที่บริษัทอนุมัติเป็นลายลักษณ์อักษร ' +
  'ใช้เป็นแนวทางเรียนรู้งานได้ แต่ถ้าเจอจุดที่ไม่ตรงกับที่ทำจริง ฝากช่วยบอกหัวหน้าเพื่อแก้ให้ถูก';

// สายงาน: id · ชื่อ · ช่วงที่ครอบคลุม · สีหมวด (ใช้ token ที่มีอยู่แล้ว) · ขั้นตอน
// ขั้นตอน: n = ลำดับ · when = เริ่มเมื่อ · act = ต้องทำอะไร · check = ต้องตรวจอะไร
//          done = ถือว่าเสร็จเมื่อ · note = ข้อควรระวัง/ที่ต้องยืนยัน · here = ขั้นที่ใช้แอพนี้
export const FLOWS = [
  {
    id: 'purchasing',
    no: '①',
    title: 'จัดซื้อ',
    scope: 'จากอยากสั่งของ ถึง supplier ยืนยันออเดอร์และเริ่มส่ง',
    cat: 'money',
    steps: [
      {
        n: 1,
        when: 'CAMP STUDIO ต้องการสั่งซื้อสินค้า',
        act: 'ขอรายละเอียดใบสั่งซื้อจาก supplier — Order Sheet · Price List · Available List',
        check: 'รายการสินค้าที่ supplier มีและพร้อมส่ง',
        done: 'ได้รับใบสั่งซื้อครบ',
      },
      {
        n: 2,
        when: 'ได้รับใบสั่งซื้อแล้ว',
        act: 'ส่งต่อให้ทีมภายใน CAMP STUDIO ตรวจ แล้วสรุปรายการที่จะสั่งจริง',
        check: 'รายการสินค้า',
        done: 'ทีมภายในสรุปรายการสั่งซื้อเสร็จ',
        note: 'ถ้าทีมภายในมีข้อสงสัยหรือคำถาม ต้องถามกลับไปที่ supplier ไม่เดาแทน',
      },
      {
        n: 3,
        when: 'ส่งสรุปรายการให้ supplier แล้ว',
        act: 'supplier ตรวจรายการและออก PI',
        check: 'รายการครบทั้งหมด และตรงกับรายการที่เราต้องการสั่งไหม',
        done: 'รายการถูกต้อง · ยืนยัน PI',
      },
      {
        n: 4,
        when: 'supplier แจ้งกำหนดการส่งสินค้า',
        act: 'อัปเดตกำหนดส่งของให้ทีมภายในทราบ',
        check: 'วันส่งสินค้า',
        done: 'ทีมภายในรับทราบ',
        note: 'ยืนยันกำหนดการส่งสินค้าให้ชัด',
      },
      {
        n: 5,
        when: 'supplier สอบถามกำหนดการชำระเงิน',
        act: 'ถามทีมภายในแล้วขอกำหนดการชำระเงิน',
        done: 'ทีมภายในแจ้งกำหนดชำระเงินกลับมา',
      },
      {
        n: 6,
        when: 'แจ้งกำหนดชำระเงินให้ supplier รับทราบแล้ว',
        act: 'ทีมภายในชำระเงินตามยอดใน PI',
        check: 'ยอดชำระเงิน',
        done: 'ชำระเสร็จ และได้รับสลิปโอนเงิน',
      },
      {
        n: 7,
        when: 'ส่งสลิปโอนเงินให้ supplier แล้ว',
        act: 'supplier ตรวจยอดและยืนยันการได้รับเงิน',
        done: 'supplier ยืนยันว่าได้รับเงินแล้ว',
      },
      {
        n: 8,
        when: 'supplier เริ่มดำเนินการส่งของ',
        act: 'แจ้ง supplier ทุกครั้งว่าเราใช้ forwarder Yusen เป็นผู้ส่งของ — ' +
             'และแลก contact person ให้ครบสองทาง (ให้ supplier รู้จัก Yusen และให้ Yusen รู้จัก supplier)',
        done: 'supplier และ Yusen ได้ contact person ของกันและกัน',
        note: 'ข้อนี้พลาดบ่อยและกระทบค่าใช้จ่ายโดยตรง',
      },
      {
        n: 9,
        when: 'เริ่มส่งของ',
        act: 'supplier ออก shipping document — Invoice · Packing list · CO · Phyto',
        check: 'ความถูกต้องของเอกสารทุกใบ',
        done: 'Yusen ได้รับเอกสารครบถ้วน',
      },
    ],
  },
  {
    id: 'import',
    no: '②',
    title: 'นำเข้า',
    scope: 'จาก supplier พร้อมส่ง ถึงของเข้าโกดังและปิดตู้',
    cat: 'ship',
    steps: [
      {
        n: 1,
        when: 'supplier จัดเตรียมสินค้าและส่งไปโกดัง Yusen',
        act: 'supplier ออก shipping document — Invoice · Packing list · CO · Phyto',
        check: 'เอกสารครบตามที่ต้องใช้',
        done: 'Yusen ได้รับเอกสารครบถ้วน',
      },
      {
        n: 2,
        when: 'Yusen หารอบที่เร็วที่สุดและแจ้งเรทค่า freight',
        act: 'ตรวจเรทในใบเสนอราคา โดยเทียบกับเรทของ shipment เก่า ๆ ว่ามีการปรับอะไรบ้าง',
        check: 'ทุกรายการในใบเสนอราคา — มีอะไรเปลี่ยนจากครั้งก่อน',
        done: 'ตรวจและยืนยันเรทค่า freight แล้ว',
        note: 'ถ้าเรทเปลี่ยน ต้องถาม Yusen ถึงเหตุผลและสาเหตุทุกครั้ง อย่ายืนยันไปเฉย ๆ',
      },
      {
        n: 3,
        when: 'Yusen คอนเฟิร์มไฟลท์',
        act: 'รับแจ้ง ETD · ETA และการออก B/L หรือ AWB',
        done: 'CAMP STUDIO ได้รับ B/L หรือ AWB',
      },
      {
        n: 4,
        when: 'ต้องให้ Yusen ตรวจพิกัดสินค้า',
        act: 'จัดทำรายละเอียดสินค้าทุกรายการที่อยู่ใน invoice ผ่าน INBOUNDpoint',
        check: 'รายละเอียดสินค้าครบทุกรายการ',
        done: 'Yusen ได้รับรายละเอียดครบ จัดทำพิกัดสินค้าและแจ้งกลับมา',
        note: 'ถ้า Yusen ขอข้อมูลสินค้าเพิ่ม ต้องให้ตามที่ขอ เพื่อประกอบการตรวจพิกัด',
        here: 'ตอนอัปโหลด invoice ในหน้าใบข้อมูลสินค้า แอพจะเตือนว่ารายการไหนต้องขอ สมอ. · เกษตร · อุทยานฯ · อื่น ๆ จากกฎพิกัดและรายการที่เคยต้องแจ้งนำเข้า — ถ้ายังไม่พบไม่ได้แปลว่าไม่ต้องขอ ฝากถามชิปปิ้งด้วยเสมอ · แท็บ สินค้า & HS → ทำรายละเอียด · แล้วที่ Console → กลุ่ม supplier → ใบข้อมูลสินค้า กด “⬇ Excel ส่งชิปปิ้ง” ส่งไฟล์ให้ Yusen (Yusen กรอกพิกัด/อากร/ใบอนุญาตลงไฟล์นี้ส่งกลับได้) หรือพิมพ์เป็น PDF',
      },
      {
        n: 5,
        when: 'Yusen ส่งผลตรวจพิกัดสินค้าทั้งหมดกลับมา',
        act: 'ตรวจความสมบูรณ์ของเอกสารที่ Yusen ส่งให้',
        check: 'รายละเอียดสินค้าพร้อมพิกัด',
        done: 'รู้ข้อกำหนดเอกสารที่ต้องใช้ทั้งหมด — ถ้าไม่ต้องใช้ Phyto หรือใบขออนุญาต สมอ. ก็ไม่ต้องทำเพิ่ม',
        note: 'รายการที่ต้องใช้ Phyto → ให้ supplier ออกให้ · รายการที่ต้องใช้ใบขออนุญาต สมอ. → ยื่นผ่านเว็บไซต์',
        here: 'แอพคำนวณช่องเอกสารที่ต้องใช้ให้เองหลังตั้งวิธีขนส่งและประเทศต้นทาง',
      },
      {
        n: 6,
        when: 'Yusen ออกดราฟใบขนให้ยืนยันความถูกต้อง',
        act: 'ตรวจดราฟใบขนทีละช่อง โดยเทียบกับ Invoice · Packing list · CO · Phyto และรายละเอียดสินค้าพร้อมพิกัด',
        check: 'ชื่อผู้รับ · ใบตราส่งสินค้า · ชื่อยานพาหนะ · วันนำเข้า · จำนวนหีบห่อ · ประเทศกำเนิด · ' +
               'ประเทศต้นทาง · ท่าหรือที่นำเข้า · พิกัดสินค้าทุกรายการ · น้ำหนัก · ราคา · ปริมาณ · ' +
               'ชื่อสินค้า · น้ำหนักรวม',
        done: 'ยืนยันความถูกต้องของดราฟใบขนกับ Yusen แล้ว',
      },
      {
        n: 7,
        when: 'Yusen แจ้งค่าภาษีและกำหนดวันส่งของ',
        act: 'แจ้งทีมภายในให้ชำระค่าภาษี และประสานทีมคลังว่าสะดวกรับสินค้าวันไหน',
        check: 'ใบขนตัวจริง',
        done: 'ทีมภายในชำระค่าภาษีแล้ว พร้อมได้สลิปโอนเงิน',
        note: 'ค่าภาษีเกิน 50,000 บาท ต้องชำระก่อนดำเนินพิธีการออกของ — เผื่อเวลาไว้ล่วงหน้า',
      },
      {
        n: 8,
        when: 'ได้สลิปโอนเงินแล้ว',
        act: 'ส่งสลิปให้ Yusen พร้อมแจ้งวันสะดวกรับสินค้า และแจ้งสถานที่ส่ง — 71 หรือ NAM',
        check: 'สลิปโอนเงิน',
        done: 'Yusen รับทราบและส่งสินค้าตามที่แจ้ง',
      },
    ],
  },
  {
    id: 'meeting',
    no: '③',
    title: 'ประชุมกับแบรนด์',
    scope: 'ก่อน ระหว่าง และหลังประชุมกับ brand หรือ supplier',
    cat: 'origin',
    steps: [
      {
        n: 1,
        when: 'supplier แจ้งว่าต้องการจัดนัดประชุม',
        act: 'รับทราบ และอ่านรายละเอียดหัวข้อการประชุม',
        check: 'เอกสารประกอบการประชุมที่ supplier แนบมา',
        done: 'ทีมภายในรับทราบ และยืนยันการนัดประชุม',
        note: 'สอบถาม agenda ให้ได้ก่อน',
      },
      {
        n: 2,
        when: 'supplier ส่งคำเชิญพร้อม agenda',
        act: 'ตรวจ agenda และดูว่าต้องเตรียมเอกสารอะไรเพิ่ม',
        check: 'เอกสารประกอบการประชุมที่ supplier ร้องขอ',
        done: 'ทีมภายในจัดทำเอกสารเสร็จ และส่งต่อให้ supplier',
      },
      {
        n: 3,
        when: 'ก่อนวันเริ่มประชุม',
        act: 'ศึกษาและเตรียมตัวให้พร้อม อ่าน agenda ให้เข้าใจ สงสัยตรงไหนถามทีมภายใน ' +
             'ถ้าได้บรีฟจากทีมภายใน จดจำไว้และใช้ให้เป็นประโยชน์',
        check: 'เอกสารประกอบการประชุม',
        done: 'เข้าใจและพร้อมเข้าประชุม',
      },
      {
        n: 4,
        when: 'ระหว่างการประชุม',
        act: 'ฟังให้เข้าใจ ไม่เข้าใจตรงไหนต้องถาม ฟังคำถามให้เข้าใจก่อนค่อยตอบ · ' +
             'คำถามไหนไม่รู้หรือไม่แน่ใจ ยังไม่ต้องตอบ — บอกไปว่าขอคุยกับทีมภายในก่อนแล้วจะตอบกลับภายหลัง',
        done: 'จบประชุมโดยเข้าใจตรงกันทั้งสองฝ่าย แล้วเริ่มทำสรุป — สรุปภายในวันหรือเช้าวันถัดไป',
        note: 'คำถามที่ยังไม่ได้ตอบ ต้องจดไว้และแจ้งทีมภายใน · หลังประชุมถ้ายังไม่เข้าใจ ถามกลับไปใหม่ได้',
      },
      {
        n: 5,
        when: 'หลังจบการประชุม',
        act: 'ทำสรุปการประชุมตามความเข้าใจของตัวเอง และตอบคำถามที่ยังค้าง · ' +
             'ถ้าได้รับสรุปจาก supplier ให้อ่านละเอียดและทำความเข้าใจก่อนสรุปให้ทีมภายในอีกครั้ง',
        check: 'สรุปการประชุมจาก supplier',
        done: 'สรุปเสร็จ และยืนยันว่าความเข้าใจของสองฝ่ายไปทางเดียวกัน',
        note: 'ตรงไหนที่เข้าใจไม่ตรงกัน ให้ปรึกษาทีมภายในก่อน แล้วแจ้ง supplier ถึงจุดที่เข้าใจผิด',
        here: 'จดสรุปไว้ในแท็บ แบรนด์ → บันทึกการประชุม แล้วงานเตือนที่ผูกกับนัดนั้นจะปิดให้เอง',
      },
      {
        n: 6,
        when: 'มีจุดที่เข้าใจผิดหรือเข้าใจไม่ตรงกัน',
        act: 'อธิบายให้ supplier เข้าใจจุดนั้น เพื่อให้ทำงานตามความเข้าใจที่ตรงกันในอนาคต',
        done: 'supplier รับทราบและเข้าใจสิ่งที่ CAMP STUDIO ต้องการสื่อสาร',
      },
    ],
  },
  {
    id: 'email',
    no: '④',
    title: 'อีเมลจากแบรนด์',
    scope: 'อีเมลทั่วไป · campaign · event · brand day · เปิดตัวสินค้าใหม่',
    cat: 'permit',
    frame: ['อ่าน', 'เกิดอะไรขึ้น', 'สำคัญกับเรายังไง', 'CAMP STUDIO ต้องทำอะไร', 'กำหนดเมื่อไร',
            'ใครต้องรู้', 'อะไรที่ยังไม่ชัด ต้องถาม', 'ลงมือ', 'ติดตาม', 'รายงาน / ปิดงาน'],
    steps: [
      {
        n: 1,
        when: 'ได้รับอีเมลจาก supplier',
        act: 'อ่านว่าเรื่องอะไร supplier ต้องการอะไร อยากได้คำตอบอะไร ' +
             'แล้วแจ้งทีมภายในให้ละเอียด',
        check: 'เอกสารที่ supplier แนบมา',
        done: 'ทีมภายในรับทราบ',
        note: 'สงสัยตรงไหนให้ถาม supplier กลับไป',
      },
      {
        n: 2,
        when: 'อีเมลเรื่อง campaign · event · brand day',
        act: 'อ่านรายละเอียดว่า supplier ต้องการอะไร อยากได้คำตอบอะไร แล้วแจ้งทีมภายในให้ละเอียด',
        check: 'เอกสารที่ supplier แนบมา',
        done: 'ทีมภายในรับทราบ',
        note: 'สงสัยตรงไหนให้ถาม supplier กลับไป',
      },
      {
        n: 3,
        when: 'อีเมลเรื่องเปิดตัวสินค้าใหม่',
        act: 'อ่านรายละเอียดสินค้าใหม่',
        check: 'รายละเอียดสินค้าใหม่ และกำหนดการวางขาย',
        done: 'ทีมภายในรับทราบ',
        note: 'สงสัยตรงไหนให้ถาม supplier กลับไป',
      },
    ],
  },
];

// หลักการทำงาน — มาจากชีต "Process Instructions" ซึ่งเป็นกติกาที่บริษัทให้ผู้ส่งมอบงานใช้เขียนขั้นตอน
// 4 ข้อนี้ใช้เป็นหลักการทำงานได้ตรง ๆ (อีก 6 ข้อเป็นกติกาเรื่องวิธีเขียน ไม่ใช่วิธีทำงาน)
export const PRINCIPLES = [
  {
    t: 'ส่งต่อแล้ว ยังไม่ถือว่าจบ',
    d: 'การ forward อีเมลหรือเอกสารไม่ถือว่าปิดงาน ทุกครั้งต้องมี: จะทำอะไรต่อ · ใครเป็นเจ้าของงาน · ' +
       'กำหนดเมื่อไร · จะติดตามวันไหน',
    src: 'กติกาข้อ 9',
  },
  {
    t: 'ไม่แน่ใจ ให้บอกว่าไม่แน่ใจ',
    d: 'ห้ามสร้างขั้นตอนหรือคำตอบขึ้นเอง ให้เขียนว่า "ต้องยืนยันกับ…" แล้วถามให้ชัดก่อน ' +
       'ดีกว่าตอบไปผิดแล้วแก้ทีหลัง',
    src: 'กติกาข้อ 10',
  },
  {
    t: 'ทุกขั้นต้องบอกได้ว่าอะไรคือเสร็จ',
    d: 'ทำเสร็จแล้วต้องได้อะไรกลับมา จึงนับว่าขั้นนั้นจบ — ถ้าตอบไม่ได้ว่าได้อะไร แปลว่ายังไม่จบ',
    src: 'กติกาข้อ 2',
  },
  {
    t: '"เช็คเอกสาร" ไม่พอ',
    d: 'ต้องบอกได้ว่าเช็คอะไร — SKU · จำนวน · ราคา · ยอดรวม · เงื่อนไข · ที่อยู่ · ETA',
    src: 'กติกาข้อ 3',
  },
];
